import Requester from "./Requester";

interface CreateDTO {
    name: number
    url: number
}

export function getStores(limit: number = 10, page: number = 1, search: string | null = null) {
    const requester = new Requester();

    return requester.get(requester.getUrl('api/stores', [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
    ]))
}

export function getStore(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/stores/${id}`))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`api/stores/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/stores`), values)
}

export default {
    create,
    getStores,
    getStore,
    destroy,
}